import Avatar from 'boring-avatars';
import { NODE_AVATAR_VARIANT, nodeAvatarSeed } from '../../utils/entity_avatar';

/**
 * A node's generated face (marble variant). Seeded by the node's id — its
 * federation server id, else its name from /info — so every peer draws the
 * same picture for it without exchanging assets. A node's superadmin can
 * reshuffle their own (Node settings → Branding); that `avatar` spec
 * ({ seed, colors }) overrides the defaults here, same as an entity's.
 *
 * Nodes are not entities, but this is the node's logo until an image is
 * uploaded (components/Node/NodeLogo.jsx), its mark in the federation
 * peers list, and — read back out of the DOM by Routes/DocumentTitle.jsx —
 * the favicon.
 */
function avatarProps(serverId, avatar) {
    return {
        name: avatar?.seed || nodeAvatarSeed(serverId),
        variant: NODE_AVATAR_VARIANT,
        colors: Array.isArray(avatar?.colors) && avatar.colors.length === 5 ? avatar.colors : undefined,
    };
}

export function NodeAvatar({ serverId, avatar = null, size = 28, square = false, style, className, onClick }) {
    return (
        <span className={className} style={{ display: 'inline-flex', lineHeight: 0, flexShrink: 0, ...style }} aria-hidden="true" onClick={onClick}>
            <Avatar {...avatarProps(serverId, avatar)} size={size} square={square} />
        </span>
    );
}

export default NodeAvatar;
